
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.5 13.86v-.933a2.43 2.43 0 0 0-.708-1.716 2.41 2.41 0 0 0-1.71-.711H3.918c-.641 0-1.256.256-1.71.71a2.43 2.43 0 0 0-.708 1.717v.933m12-7.36v4m2-2h-4M8.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"}})])
          )
        }
      }
    